<style>

  .input{
    display: grid;
    grid-template-columns: 55px 15px;
  }
  .number{
    grid-column: 1;
  }
  .arrow{
    grid-column: 2;
  }
  
  .date{
    border: 1px rgba(0,0,0,0) solid;
    padding: 10px;
    text-align: center;
  }
  .sel{
    border: 1px rgba(0,0,0,1) solid;
    background-color: rgba(0,0,0,0.7);
    color: white;
  }
  
  </style>
  
  <Dialog show="{showYears}" title="Select A Date" buttons="{buttons}" on:close="{ () => showYears = false}" on:done="{done}">
    
    {#each allYears as item}
      <div class="date {item == selY ? 'sel' : ''}" on:click="{ () => uSelY(item) }">{item}</div>
    {/each}
    
  </Dialog>
  
  <div class="input" on:click="{ () => showYears = true }">
    <div class="month">{year}</div>
    <div class="arrow"><i class="icon-keyboard_arrow_down"></i></div>
  </div>
  
  
  <script>
  
  import Dialog from "./Dialog.svelte";
  
  export let year = "YYYY";
  
  import { onMount } from "svelte";
  onMount(async () => {
    // must be at least 18 to sign up
    let curYear = new Date().getFullYear() - 18;
    allYears = [];
    for (let i = curYear; i >= (curYear - 82); i--) {
      allYears.push(i);
    }
  });
  
  let showYears = false;
  let buttons = [ {text: "Done", callback: "done", disabled: true, } ]
  let selY = 0;
  let allYears = [];
  
  
  function uSelY(i) {
    selY = i;
    buttons[0].disabled = false;
  }
  
  function done() {
    if (selY != 0) year = selY;
    showYears = false;
  }
  
  
  </script>